import React, { useEffect, useMemo, useState } from 'react';
import DeluxeWalletButtons from '../DeluxeWalletButtons';
import './deluxe-booking-payment-tabs.css';

function isApplePayAvailable() {
  try {
    return Boolean(window.ApplePaySession?.canMakePayments?.());
  } catch {
    return false;
  }
}

export default function DeluxeBookingPaymentTabs({
  wallets,
  disabled = false,
  cardForm,
  onWalletSuccess,
  onWalletError,
}) {
  const showWallets = Boolean(wallets?.jwt && wallets?.scriptUrl);
  const showApplePay = showWallets && isApplePayAvailable();
  const [tab, setTab] = useState('card');

  const tabs = useMemo(() => {
    const next = [{ id: 'card', label: 'Card' }];
    if (showWallets) next.push({ id: 'googlePay', label: 'Google Pay' });
    if (showApplePay) next.push({ id: 'applePay', label: 'Apple Pay' });
    return next;
  }, [showWallets, showApplePay]);

  useEffect(() => {
    if (!tabs.some((item) => item.id === tab)) setTab('card');
  }, [tab, tabs]);

  if (!showWallets) return cardForm;

  return (
    <div className="deluxe-pay-tabs">
      <div className="deluxe-pay-tabs__list" role="tablist" aria-label="Payment method">
        {tabs.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            id={`deluxe-pay-tab-${item.id}`}
            aria-selected={tab === item.id}
            aria-controls={`deluxe-pay-panel-${item.id}`}
            className={`deluxe-pay-tabs__tab ${tab === item.id ? 'deluxe-pay-tabs__tab--active' : ''}`}
            onClick={() => setTab(item.id)}
            disabled={disabled}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div
        id={`deluxe-pay-panel-${tab}`}
        role="tabpanel"
        aria-labelledby={`deluxe-pay-tab-${tab}`}
        className="deluxe-pay-tabs__panel"
      >
        {tab === 'card' ? cardForm : null}
        {tab === 'googlePay' ? (
          <DeluxeWalletButtons
            method="googlePay"
            jwt={wallets.jwt}
            scriptUrl={wallets.scriptUrl}
            disabled={disabled}
            onSuccess={onWalletSuccess}
            onError={onWalletError}
          />
        ) : null}
        {tab === 'applePay' ? (
          <DeluxeWalletButtons
            method="applePay"
            jwt={wallets.jwt}
            scriptUrl={wallets.scriptUrl}
            disabled={disabled}
            onSuccess={onWalletSuccess}
            onError={onWalletError}
          />
        ) : null}
      </div>
    </div>
  );
}
